import { render } from "./app-header.vue?vue&type=template&id=3097b3f1"
import script from "./app-header.vue?vue&type=script&lang=js"
export * from "./app-header.vue?vue&type=script&lang=js"

import "./app-header.vue?vue&type=style&index=0&id=3097b3f1&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__